import React, { useEffect, useState } from 'react'
import Header from '../../Core/Header'
import { Section } from '../../Core/Section'
import { allProductToSell, confirmCheckoutHandle, confirmCheckoutStore, getCheckoutList, getStoreCheckoutList } from '../../Services/Operations/ProductAPI'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { logDOM } from '@testing-library/dom'

const data=[
    {
        id:1,
        date:"2025-01-01",
        customerName:"John Doe",
        totalAmount:100,
        grandAmount:100,
        status:"paid",
        listofProducts:[
            {productName:"Product 1", quantity:2, price:50},
            {productName:"Product 2", quantity:1, price:50},
            {productName:"Product 3", quantity:1, price:50},
             {productName:"Product 1", quantity:2, price:50},
            {productName:"Product 2", quantity:1, price:50},
            {productName:"Product 3", quantity:1, price:50},
             {productName:"Product 1", quantity:2, price:50},
            {productName:"Product 2", quantity:1, price:50},
            {productName:"Product 3", quantity:1, price:50},
        ],

    },
    {
        id:2,
        date:"2025-01-01",
        customerName:"John Doe",
        totalAmount:100,
        grandAmount:100,
        status:"paid",
        listofProducts:[
            {productName:"Product 1", quantity:2, price:50},
            {productName:"Product 2", quantity:1, price:50},
            {productName:"Product 3", quantity:1, price:50}
        ],

    },
    {
        id:3,
        date:"2025-01-01",
        customerName:"John Doe",
        totalAmount:100,
        grandAmount:100,
        status:"paid",
        listofProducts:[
            {productName:"Product 1", quantity:2, price:50},
            {productName:"Product 2", quantity:1, price:50},
            {productName:"Product 3", quantity:1, price:50}
        ],

    },
    {
        id:4,
        date:"2025-01-01",
        customerName:"John Doe",
        totalAmount:100,
        grandAmount:100,
        status:"paid",
        listofProducts:[
            {productName:"Product 1", quantity:2, price:50},
            {productName:"Product 2", quantity:1, price:50},
            {productName:"Product 3", quantity:1, price:50}
        ],

    },
    {
        id:5,
        date:"2025-01-01",
        customerName:"John Doe",
        totalAmount:100,
        grandAmount:100,
        status:"paid",
        listofProducts:[
            {productName:"Product 1", quantity:2, price:50},
            {productName:"Product 2", quantity:1, price:50},
            {productName:"Product 3", quantity:1, price:50}
        ],

    },
    {
        id:6,
        date:"2025-01-01",
        customerName:"John Doe",
        totalAmount:100,
        grandAmount:100,
        status:"paid",
        listofProducts:[
            {productName:"Product 1", quantity:2, price:50},
            {productName:"Product 2", quantity:1, price:50},
            {productName:"Product 3", quantity:1, price:50}
        ],

    },
    {
        id:7,
        date:"2025-01-01",
        customerName:"John Doe",
        totalAmount:100,
        grandAmount:100,
        status:"paid",
        listofProducts:[
            {productName:"Product 1", quantity:2, price:50},
            {productName:"Product 2", quantity:1, price:50},
            {productName:"Product 3", quantity:1, price:50}
        ],

    },
    {
        id:8,
        date:"2025-01-01",
        customerName:"John Doe",
        totalAmount:100,
        grandAmount:100,
        status:"paid",
        listofProducts:[
            {productName:"Product 1", quantity:2, price:50},
            {productName:"Product 2", quantity:1, price:50},
            {productName:"Product 3", quantity:1, price:50}
        ],

    },
    {
        id:9,
        date:"2025-01-01",
        customerName:"John Doe",
        totalAmount:100,
        grandAmount:100,
        status:"paid",
        listofProducts:[
            {productName:"Product 1", quantity:2, price:50},
            {productName:"Product 2", quantity:1, price:50},
            {productName:"Product 3", quantity:1, price:50}
        ],

    },
    {
        id:10,
        date:"2025-01-01",
        customerName:"John Doe",
        totalAmount:100,
        grandAmount:100,
        status:"paid",
        listofProducts:[
            {productName:"Product 1", quantity:2, price:50},
            {productName:"Product 2", quantity:1, price:50},
            {productName:"Product 3", quantity:1, price:50}
        ],

    },
    {
        id:11,
        date:"2025-01-01",
        customerName:"John Doe",
        totalAmount:100,
        grandAmount:100,
        status:"paid",
        listofProducts:[
            {productName:"Product 1", quantity:2, price:50},
            {productName:"Product 2", quantity:1, price:50},
            {productName:"Product 3", quantity:1, price:50}
        ],

    },
    {
        id:12,
        date:"2025-01-01",
        customerName:"John Doe",
        totalAmount:100,
        grandAmount:100,
        status:"paid",
        listofProducts:[
            {productName:"Product 1", quantity:2, price:50},
            {productName:"Product 2", quantity:1, price:50},
            {productName:"Product 3", quantity:1, price:50}
        ],

    },
    {
        id:13,
        date:"2025-01-01",
        customerName:"John Doe",
        totalAmount:100,
        grandAmount:100,
        status:"paid",
        listofProducts:[
            {productName:"Product 1", quantity:2, price:50},
            {productName:"Product 2", quantity:1, price:50},
            {productName:"Product 3", quantity:1, price:50}
        ],

    },
    {
        id:14,
        date:"2025-01-01",
        customerName:"John Doe",
        totalAmount:100,
        grandAmount:100,
        status:"paid",
        listofProducts:[
            {productName:"Product 1", quantity:2, price:50},
            {productName:"Product 2", quantity:1, price:50},
            {productName:"Product 3", quantity:1, price:50}
        ],

    },
    {
        id:15,
        date:"2025-01-01",
        customerName:"John Doe",
        totalAmount:100,
        grandAmount:100,
        status:"paid",
        listofProducts:[
            {productName:"Product 1", quantity:2, price:50},
            {productName:"Product 2", quantity:1, price:50},
            {productName:"Product 3", quantity:1, price:50}
        ],

    }
    ,{
        id:16,
        date:"2025-01-01",
        customerName:"John Doe",
        totalAmount:100,
        grandAmount:100,
        status:"paid",
        listofProducts:[
            {productName:"Product 1", quantity:2, price:50},
            {productName:"Product 2", quantity:1, price:50},
            {productName:"Product 3", quantity:1, price:50}
        ],

    }
]

const StoreConfirmCheckout = () => {

    const navigate = useNavigate();
      const token = useSelector((state) => state.user.token);

    const[conformedCheckout,setConformedCheckout] = useState(data)
    const[createdCheckout,setCreatedCheckout] = useState(data)
    const[all,setAll]=useState(data)
    const[activeIndex, setActiveIndex] = useState(null);
    const[activeItem,setActiveItem]=useState(null)
    const [load,setLoad]=useState(null)
    const [availableProducts,setAvailableProducts]=useState([])
    const[modal,setModal]=useState(false)
    const[modalProducts,setModalProducts]=useState(null)
    const [dispatchData,setDispatchdata]=useState([])
    const[currentOrder,setCurrentOrder]=useState(null)
    const [checkOut,setCheckout]=useState(null)
    let selectedNums=[]
    const [numbers,setNumbers]=useState([])

    const fetchCheckouts=async()=>{
        if(!token){
            navigate('/login')
            return;
        }

        try {
           
             const response = await getStoreCheckoutList(token)
            console.log("Checkout List: ", response);
            
           
            setAll(response)

            const created=response.filter(item=>item.orderStatus==="PENDING")
            setCreatedCheckout(created)
            const confirmed=response.filter(item=>item.orderStatus!=="PENDING")
            setConformedCheckout(confirmed)
            
        } catch (error) {
            console.log(error);
            
        }
    }

    const allProductAvailableToSell = async () => {
                  try {
                    const res = await allProductToSell(token);
                    console.log(res);
                    if (res.status === 200) {
                      
                      setAvailableProducts(res.data);
                      console.log("setAvailableProducts : ",res.data)
                      
                    }
                  } catch (error) {
                    console.log(error);
                  }
                };

    useEffect(() => { 
    fetchCheckouts()
    allProductAvailableToSell()
   
  
    }, [])

    const handleConformedCheckout = async() => {
        
        console.log('data',dispatchData);
        
        try {
            const response = await confirmCheckoutStore(currentOrder, token,dispatchData);
            console.log("Conformed Checkout: ", response);
            if(response.status===200){
                fetchCheckouts()
                toast.success("Checkout confirmed")
                setNumbers([])
                setModal(false)
                setDispatchdata([])
                selectedNums=[]
            }
            
        } catch (error) {
            console.log(error);
            
        }finally{
            setLoad(null)
        }
        console.log("Conformed Checkout: ", );
        
    }

    const dateFormate=(date)=>{
        let d=new Date(date)

        return d.toLocaleDateString()
    }

    const findCheckout=(id)=>{
       let order= all.find(item => item.checkoutId === id)
       return order
    }

    const handleModal=async(checkoutId)=>{
        setCurrentOrder(checkoutId)

        const currentOrder=createdCheckout.find(c=>c.id===checkoutId)
        setCheckout(currentOrder)
        console.log(currentOrder);

        let track=(currentOrder.items).map(({productId,quantity})=>(
           {productId,quantity}
        ))
        
        let data=[]

      await ( currentOrder.items)?.map(ele => {
       let list= availableProducts.filter(product=>product.productId===ele.productId)
console.log("list",list,track);


const merged = list.map(product => {
  // find matching item in second list
  const ref = track.find(c => c.productId === product.productId);

  return {
    ...product,
    quantity: ref ? ref.quantity : null // add missing field
  };
});

        data=[...data,merged]

       });


       console.log("modal",data);
       setModalProducts(data)
       setModal(true)
       
    }

   const addSerailNumber=(productid,number,qnt)=>{
       
        console.log(dispatchData);
        

       const prod=(checkOut.items)?.find(p=>p?.productId===productid)

       let d= dispatchData.find(data=>data.productId===productid)
     //  dispatchData=dispatchData.filter(data=>data.productId!==productid)
       if(d){
        console.log("found",d,dispatchData);
        
        if(!d.serialNumbers.includes(number)&& d.quantity>=qnt) {
            console.log("limit reached");
            return
        }

        if(!d.serialNumbers.includes(number))
       { d.serialNumbers.push(number)
        selectedNums.push(number)
        d.quantity++
        setNumbers((prev)=>[...prev,number])
        
       }
        else{
            d.serialNumbers=d.serialNumbers.filter(num=>num!==number)
            selectedNums=selectedNums.filter(num=>num!==number)
            d.quantity--;
            let list=numbers.filter(p=>p!==number)
            setNumbers(list)
           
        }

      //  dispatchData=[...dispatchData,d]
        
       }else{
        // dispatchData.push({
        //     productId:productid,
        //     serialNumbers:[number],
        //     quantity:1
        // })
        setDispatchdata(prev=>[...prev,{
            productId:productid,
            serialNumbers:[number],
            quantity:1
        }])
        setNumbers((prev)=>[...prev,number])
          selectedNums.push(number)

       }
    //  setSelectedNums((prev)=>[...prev,number])
       console.log(dispatchData,selectedNums);
       

    }


    


  return (
   <div id="main_content">
    <Header/>
    <div className="page">
        <Section />
        <div className="section-body"
        style={{height: "80vh",width:"100%", display: "flex", justifyContent: "center", alignItems:"start"}}
        >
            <div style={{width:"50%"}}>
                <h3>All store checkouts</h3>
                <p>{"  "}</p>
                <p>Confirmed Checkouts:({conformedCheckout.length})</p>

                <div style={{display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"left",maxHeight:"70vh",overflowY:"auto"}}>
                    {
                        conformedCheckout.map((item) => (
                            <div key={item.id} style={{borderLeft:"5px solid black",width:"80%", margin:"10px", padding:"10px",borderRadius:"8px", boxShadow:"0 0 10px rgba(0,0,0,0.1)",background:'linear-gradient(to right, #fda39dff, #fc3d37ff)'}}>
                                <p style={{display:"flex",justifyContent:"space-between"}}>
                                    <span style={{display:"flex",padding:"5px",borderRadius:"3px",borderLeft:"3px solid gray",borderTop:"2px solid gray",fontSize:"12px"}}>Checkout ID: {item.id}</span>
                                    <span style={{fontSize:"10px",fontWeight:"bold",color:"black"}}> {dateFormate(item.createdAt)}</span></p>
                                
                                <p style={{display:"flex",justifyContent:"space-between"}}>
                                    <span style={{fontWeight:"bold",fontSize:"18px"}}>Customer: {item.storeName}</span>
                                    <span onClick={()=>{setActiveIndex(item.id);setActiveItem(item)}}>
                                        <img src={activeIndex===item.id?'/assets/images/gallery/view.png':'/assets/images/gallery/hide.png'} style={{width:"18px",height:"18px"}}/>
                                    </span>
                                     </p>

                                    <p style={{display:"flex",justifyContent:"space-between",fontSize:"10px"}}>{item.orderStatus}
                                    </p>

                                    <p style={{display:"flex",justifyContent:"space-between"}}>
                                    <span style={{fontWeight:"100",fontSize:"12px",color:"white",padding:"10px",backgroundColor:"black",borderRadius:"5px",marginRight:"5px"}}>
                                        {item.storeType}
                                        </span>
                                        <span style={{fontWeight:"100",fontSize:"12px",color:"black",padding:"10px",backgroundColor:"white",borderRadius:"5px"}}>
                                          Grand Amount: {item.grandTotal}  
                                        </span>
                                    </p>
                                       
                                
                                
                                
                                {/* <h4>List of Products:</h4>
                                <ul>
                                    {
                                        item.listofProducts.map((product, index) => (
                                            <li key={index}>
                                                {product.productName} - Quantity: {product.quantity}, Price: {product.price}
                                            </li>
                                        ))
                                    }
                                </ul> */}
                            </div>
                        ))
                    }

                </div>

               

            </div>

            <div style={{width:"50%", position:"relative"}}>
                <h3>Created Checkout : ({createdCheckout.length})</h3>
                <p>Confirm these checkouts----</p>
                
                 <div style={{display:"flex",width:"100%", flexDirection:"column", alignItems:"center", justifyContent:"left",maxHeight:"70vh",overflowY:"auto"}}>
                    {
                        createdCheckout.map((item) => (
                            <div key={item.checkoutId} style={{borderRight:"5px solid black",width:"80%", margin:"10px", padding:"10px",borderRadius:"8px",background:'linear-gradient(to right, gray,whitesmoke)'}}>
                                <p style={{display:"flex",justifyContent:"space-between"}}>
                                    <span style={{display:"flex",padding:"5px",borderRadius:"3px",border:"1px solid lightblue",fontSize:"12px",background:'linear-gradient(to right, gray,whitesmoke)'}}>Checkout ID: {item.id}</span>
                                    <span style={{fontSize:"10px",fontWeight:"bold",color:"black"}}> {dateFormate(item.createdAt)}</span></p>
                                
                                <p style={{display:"flex",justifyContent:"space-between"}}>
                                    <span style={{fontWeight:"bold",fontSize:"18px"}}>Customer: {item.storeName}</span>
                                    <span onClick={()=>{setActiveIndex(item.id);
                                        setActiveItem(item )
                                    }
                                    }>
                                        <img src={activeIndex===item.id?'/assets/images/gallery/view.png':'/assets/images/gallery/hide.png'} style={{width:"18px",height:"18px"}}/>
                                    </span>
                                     </p>
                                <p style={{display:"flex",justifyContent:"space-between"}}>
                                    <span style={{borderLeft:"3px solid red",padding:"5px",fontSize:"14px"}}>{item.orderStatus}</span>
                                    <span style={{borderLeft:"1.5px solid blue",padding:"5px",fontSize:"14px"}}>Total products: {item?.items?.length}</span>
                                    <span onClick={()=>handleModal(item.id)}
                                     style={{background:'linear-gradient(to top, gray,black)',borderRadius:"10px",padding:"5px",color:"#ffff",cursor:"pointer"}}>
                                        {item.id===load?"Processing..":"Dispatch"}</span></p>

                                    <p>
                                    <span style={{fontWeight:"100",fontSize:"12px",color:"white",padding:"10px",backgroundColor:"gray",borderRadius:"5px",marginRight:"5px"}}>
                                        Total Amount: {item.grandTotal}
                                        </span>
                                        <span style={{fontWeight:"100",fontSize:"12px",color:"black",padding:"10px",backgroundColor:"gainsboro",borderRadius:"5px"}}>
                                          {item.storeType}  
                                        </span></p>
                                       
                                
                                
                              
                                {/* <h4>List of Products:</h4>
                                <ul>
                                    {
                                        item.listofProducts.map((product, index) => (
                                            <li key={index}>
                                                {product.productName} - Quantity: {product.quantity}, Price: {product.price}
                                            </li>
                                        ))
                                    }
                                </ul> */}
                            </div>
                        ))
                    }

                </div>

                {activeIndex!==null?<div 
                style={{position:"fixed",color:"white",backgroundColor:"gray",width:"400px",padding:"20px",borderRadius:"10px",boxShadow:"0 0 10px rgba(0,0,0,0.1)",zIndex:100,top:"50%",left:"50%",transform:"translate(-50%,-50%)",border:"1px solid lightblue"}}>

                    {
                       (
                            <div>
                                <p style={{display:"flex",justifyContent:"space-between"}}>
                                    <h4 style={{borderTop:"1px solid black", borderLeft:"3px solid black",padding:"5px",display:"flex",flexDirection:"column",}}>{activeItem?.customerName?activeItem.customerName:"__customer__"}
                                         <span style={{fontSize:"10px",fontWeight:"bold",color:"black"}}> {dateFormate(activeItem.createdAt)}</span>
                                        </h4> 
                                   
                                <span onClick={()=>{setActiveIndex(null) } } style={{padding:"5px",fontSize:"10px",borderRadius:"4px",border:"1px solid lightblue",cursor:"pointer"}}>cancel</span></p>
                                 
                                 <p>address:{activeItem?.address}</p>
                                <p>{activeItem?.city}, {activeItem?.state}, {activeItem?.pincode}</p>
                                <p>{activeItem?.status}</p>
                                <h4>List of Products:</h4>
                                <ul style={{listStyleType:"none", maxHeight:"150px", overflowY:"auto"}}>
                                    {
                                        activeItem?.items.map((product, index) => (
                                            <li key={index}>
                                             <p>  <span>{product.productName}</span> <span>- quantity: {product.quantity}</span></p>  
                                            </li>
                                        ))
                                    }
                                </ul> 
                                </div>
                        )
                    }


                </div>:""}

            </div>

        </div>


        <div className="section-body">
          <footer className="footer">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-6 col-sm-12">
                  Copyright © 2025{" "}
                  <a href="">Technology support By - Siance Software Pvt Ltd</a>
                  .
                </div>
                {/* <div className="col-md-6 col-sm-12 text-md-right">
                  <ul className="list-inline mb-0">
                    <li className="list-inline-item">
                      <a href="../doc/index.html">Documentation</a>
                    </li>
                    <li className="list-inline-item">
                      <a href="javascript:void(0)">FAQ</a>
                    </li>
                    <li className="list-inline-item">
                      <a
                        href="javascript:void(0)"
                        className="btn btn-outline-primary btn-sm"
                      >
                        Buy Now
                      </a>
                    </li>
                  </ul>
                </div> */}
              </div>
            </div>
          </footer>
        </div>
    </div>

   {modal && <div 
   style={{position:"absolute",zIndex:1000,top:"150px",right:"100px",backgroundColor:"white",padding:"10px",width:"350px",borderRadius:"10px",border:"3px solid gray"}}>

   <div style={{display:"flex",justifyContent:"space-between",padding:"10px"}}> 
    <p onClick={()=>console.log(modalProducts)}>products and their serial numbers</p>

                    <p style={{cursor:"pointer"}}
                    onClick={()=>{
                        setModal(false)
                        setModalProducts(null)
                        selectedNums=[]
                        setNumbers([])
                     
              
                setDispatchdata([])
               
                    }}>X</p>
                    </div>
   
   
   <div style={{height:"350px",maxHeight:"350px",overflowY:"auto"}}> 
    {
        !modalProducts?
        "loading..."
       : modalProducts?.map((p,indx)=>
        
         {   
            return(

            <div key={indx} style={{border:"0.5px solid black", padding:"10px",margin:"8px",borderRadius:"15px"}}>

            <p style={{fontSize:"20px"}}>{p[0].productName}</p>
      
            <p>required quantity {p[0].quantity}</p>
             
            <div>
            <p> available serial numbers</p>
            {p[0].serialNumbers?.map(num=>
            <p style={{border:"0.3px solid black",padding:"4px",cursor:"pointer",
                backgroundColor:numbers.includes(num.serialNumber)?"gray":"white",
                borderRadius:"10px",fontSize:"12px"
            }}
            onClick={()=>{addSerailNumber(p[0].productId,num.serialNumber,p[0].quantity);
                console.log(selectedNums.includes(String(num.serialNumber)));
                
               
            }}
            >
              <span>{num.serialNumber} </span> {"       "}
              <span>{numbers.includes(num.serialNumber)?"✔️":""}</span>
            </p>)
            
            }</div>




            </div>
        )}
    )
   

    }
    </div>

    <p onClick={handleConformedCheckout} 
    style={{cursor:"pointer",margin:"10px",padding:"5px",backgroundColor:"gray",width:"fit-content",fontWeight:800,textAlign:"center",borderRadius:"10px"}}>
        confirm</p>




    </div>}
   </div>
  )
}

export default StoreConfirmCheckout